import './main.css';
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import Sider from "../../comps/sider/main";
import { Popconfirm , Alert, Skeleton, Card, message, Col, Row, Statistic, Tooltip, Empty, Button, Collapse, Popover, Divider, Modal, Segmented, Tag, Drawer, Space, Input, Upload } from "antd";
import { CopyTwoTone, EditTwoTone, UploadOutlined, EyeOutlined, SendOutlined, CommentOutlined , LinkOutlined, DeleteOutlined } from '@ant-design/icons';
import { EditText, EditTextarea } from 'react-edit-text';
import callAPI from "../../comps/fetch/main";


function Oia() {


    const navigate = useNavigate();
    const [messageApi, contextHolder] = message.useMessage();
    const [showDrawer, setShowDrawer] = useState(false)
    const [showCreate, setShowCreate] = useState(false)
    const [drawerData, setDrawerData] = useState({})
    const [newURL, setNewURL] = useState({})
    const [callPostAPI, setCallPostAPI] = useState(false)
    const [loading, setLoading] = useState(false)
    const [dataPostedState, setDataPostedState] = useState()


    const [links, setLinks] = useState(undefined)
    const [nexPageToken, setNexPageToken] = useState()

    const [deleteLink, setDeleteLink] = useState()
    const [deleteState, setDeleteState] = useState()


    const domainMap = {
        "youtube": "yt",
        "yt": "yt",
        "yout": "yt",
        "ytb": "yt",
        "instagram": "ig",
        "ig": "ig",
        "insta": "ig",
        "igram": "ig",
        "facebook": "fb",
        "fb": "fb",
        "face": "fb",
        "fbook": "fb",
        "twitter": "tw",
        "tw": "tw",
        "twt": "tw",
        "tweet": "tw",
        "reddit": "rd",
        "rd": "rd",
        "redd": "rd",
        "pinterest": "pn",
        "pn": "pn",
        "pin": "pn",
        "pint": "pn",
        "linkedin": "lkdin",
        "ln": "lkdin",
        "link": "lkdin",
        "tiktok": "tk",
        "tk": "tk",
        "tik": "tk",
        "ttok": "tk",
        "snapchat": "sc",
        "sc": "sc",
        "snap": "sc",
        "chat": "sc",
        "whatsapp": "wa",
        "wa": "wa",
        "whats": "wa",
        "wapp": "wa",
        "google": "g",
        "g": "g",
        "goo": "g",
        "amazon": "amz",
        "am": "amz",
        "amz": "amz",
        "wikipedia": "wp",
        "wp": "wp",
        "wiki": "wp",
        "pedia": "wp",
        "ebay": "eb",
        "eb": "eb",
        "dropbox": "db",
        "db": "db",
        "drop": "db",
        "box": "db",
        "spotify": "sp",
        "sp": "sp",
        "spot": "sp",
        "ify": "sp",
        "netflix": "nf",
        "nf": "nf",
        "net": "nf",
        "flix": "nf",
        "flipkart": "fk",
        "fk": "fk",
        "flip": "fk",
        "kart": "fk",
        "amazon.in": "ai",
        "ai": "ai",
        "amz": "ai",
        "paytm": "pt",
        "pt": "pt",
        "pay": "pt",
        "tm": "pt",
        "ola": "ol",
        "ol": "ol",
        "ola": "ol",
        "cab": "ol",
        "zomato": "zm",
        "zm": "zm",
        "zom": "zm",
        "ato": "zm",
        "swiggy": "sg",
        "sg": "sg",
        "swig": "sg",
        "gy": "sg",
        "bookmyshow": "bms",
        "bms": "bms",
        "book": "bms",
        "show": "bms",
        "makemytrip": "mmt",
        "mmt": "mmt",
        "make": "mmt",
        "trip": "mmt",
        "goibibo": "gb",
        "gb": "gb",
        "gib": "gb",
        "ibo": "gb",
        "rediff": "rd",
        "rd": "rd",
        "red": "rd",
        "iff": "rd",
        "naukri": "nk",
        "nk": "nk",
        "nau": "nk",
        "kri": "nk",
        "olx": "olx",
        "olx": "olx",
        "ol": "olx",
        "x": "olx",
        "quikr": "qk",
        "qk": "qk",
        "quik": "qk",
        "r": "qk",
        "gaana": "gn",
        "gn": "gn",
        "gaa": "gn",
        "na": "gn",
        "jio": "ji",
        "ji": "ji",
        "jio": "ji",
        "rel": "ji",
        "airtel": "at",
        "at": "at",
        "air": "at",
        "tel": "at",
        "vodafone": "vf",
        "vf": "vf",
        "vod": "vf",
        "fone": "vf",
        
      };
    


      
      function getShortDomain(url) {


        try {
            let parsedUrl = ""
            try{
                 parsedUrl = new URL(url);
            }
            catch(error){
                parsedUrl = new URL(`https://${url}`)
            }
            
            const hostnameParts = parsedUrl.hostname.split('.');
        
            // Remove subdomains (e.g., "www", "subdomain")
            const domainParts = hostnameParts.slice(-2); 
        
            return  domainMap[domainParts[0]] || domainParts[0];
          } catch (error) {
            console.error("Invalid URL:", error);
            return url;
          }

        
      }


      const handleImageError = (event) => {
        event.target.src = "https://public-assets.instantdm.com/4906292.png" ;
    };


    useEffect(() => {

        if(deleteState == undefined){
            return
        }
        if(deleteState.code == 200){
            messageApi.destroy()
            message.success("Deleted!")
            setDeleteState(undefined)
        }

    }, [deleteState])

    useEffect(() => {

        if (deleteLink == undefined){
            return
        }
        messageApi.open({type: 'loading',
            content: 'Deleteing...',
            duration: 0,
            key:'deleting'
          })
        let apiURL = `/short_url`
        callAPI({ url: apiURL, method: "DELETE", body:{"short_url":deleteLink.short_url }, loadingState: setLoading, dataState: setDeleteState })
        let temp_List = links
        temp_List.splice(deleteLink.index, 1)
        setLinks([...temp_List])
    } , [deleteLink])




    useEffect(() => {
        if (links == undefined) {
            return
        }
        // console.log("===LINKS========", links)
        if (Array.isArray(links) != true) {
            messageApi.destroy()
            setLinks(links.short_urls)
            // setLinks([])
            setNexPageToken(links.next_page_token)
            return
        }

    }, [links])

    useEffect(() => {
        if (links == undefined) {
            messageApi.open({type: 'loading',
                content: 'Loading your smart links...',
                duration: 0,
                key:'loading'
              })
            let apiURL = `/short_url`
            callAPI({ url: apiURL, method: "GET", loadingState: setLoading, dataState: setLinks })
        }
    }, [])

    useEffect(() => {
        if (dataPostedState == undefined) {
            return
        }

        if (dataPostedState?.code == 200) {
            setShowCreate(false)
            setCallPostAPI(false)
            setLinks([dataPostedState.data, ...links])
            setDataPostedState()
        }
    }, [dataPostedState])


    useEffect(() => {
        if (callPostAPI == true) {
            let apiURL = `/short_url`
            callAPI({ url: apiURL, method: "POST", body: { "url": newURL }, loadingState: setLoading, dataState: setDataPostedState })
        }
    }, [callPostAPI])



    let collaps_items = [
        {
            
                key: '1',
                label: 'What is smart link?',
                children: <p>Smart Link allows your audience to view content directly in the app without visiting a browser. If the app is not installed, the link will open directly in the browser. Additionally, our smart analytics provides insights into whether the content was viewed by a human or a bot, helping you to better understand your audience's engagement.</p>,
              
        }
    ]


    return (
        <div className="page-layout">
            {contextHolder}

            <Sider />
            
            <div className="page-content">

                <div className='desktop row' style={{padding:'20px'}}>
                <div className='page-title'>
                    <h1>Instant Open - Open In App and Short URLs  <Tag color="purple" style={{marginLeft:'10px' , fontSize:'14px' , fontWeight:'normal'}}>Beta</Tag> </h1>
                    <p>You can create links that directly opens in the app and you can create short urls.</p>
                </div>
                <div className='create-btn' onClick={() => { setShowCreate(true) }}>
                    Create smart link
                </div>
                </div>
                <div className='mobile' style={{padding:'20px'}}>
                <div className='page-title'>
                    <h1>Instant Open -Open In App and Short URLs <Tag color="purple" style={{marginLeft:'10px' , fontSize:'14px' , fontWeight:'normal'}}>Beta</Tag></h1>
                    <p>You can create links that directly opens in the app and you can create short urls.</p>
                </div>
                <div className='create-btn' onClick={() => { setShowCreate(true) }}>
                    Create smart link
                </div>
                </div>

                <div className='links-container'>

                    {
                        Array.isArray(links) != true ? <p></p> : links.map((link, index) => <div className='link-box' >
                            <div className='row'>
                                <div className='link-box-img'>
                                    <img src={link.link_preview?.image} onError={handleImageError} />
                                    <div>
                                    <Tooltip title={link.link_preview?.title || getShortDomain(link.long_url	) }>
                                    <p className='link-box-title'>{link.link_preview?.title || getShortDomain(link.long_url	) }</p>
                                    </Tooltip>
                                    <p style={{fontSize:'10px', color:'grey'}}>{link.long_url}</p>
                                    </div>
                                </div>
                                <div className='desktop row' style={{gap:'10px', opacity:'.5'}}>
                                    <Tooltip title="No of real user visited your content">
                                    <div>
                                        <p style={{fontSize:'14px'}}>{link.clicks || 0}</p>
                                        {/* <EyeOutlined /> */}
                                        <p style={{fontSize:'12px'}}>Clicks</p>
                                    </div>
                                    </Tooltip>
                                    <Tooltip title="No of times your content shared over internet or crawled by bot.">
                                    <div>
                                        <p style={{fontSize:'14px'}}>{link.shares || 0}</p>
                                        {/* <SendOutlined /> */}
                                        <p style={{fontSize:'12px'}}>Previews</p>
                                    </div>
                                    </Tooltip>
                                </div>
                            </div>
                            <p className='date-created desktop'>
                                {new Date(link.created_at).toLocaleString('en-GB',
                                    {
                                        day: 'numeric',
                                        month: 'short',
                                        year: 'numeric'
                                    })}
                            </p>
                            <div className='short-link row'>
                                
                                <Tooltip title="Click to copy">
                                <p onClick={() => {
                                    navigator.clipboard.writeText(`https://${getShortDomain(link.long_url)}.opnin.app/${link.short_url}`)
                                        .then(() => {
                                            message.success("Copied to clipboard!")
                                        })
                                        .catch(err => {
                                            console.error("Failed to copy text: ", err);
                                        });
                                }}>{getShortDomain(link.long_url)}.opnin.app/{link.short_url}</p>
                                </Tooltip>
                                <div className='row' style={{gap:'14px'}}>
                                <CopyTwoTone className='copy-icon icon' onClick={() => {
                                    navigator.clipboard.writeText(`https://${getShortDomain(link.long_url)}.opnin.app/${link.short_url}`)
                                        .then(() => {
                                            message.success("Copied to clipboard!")
                                        })
                                        .catch(err => {
                                            console.error("Failed to copy text: ", err);
                                        });
                                }} />
                                {/* <EditTwoTone className='icon' onClick={() => { setDrawerData(link); setShowDrawer(true) }} /> */}
                                
                                <Popconfirm
                                    title="Delete the smart link?"
                                    description="Are you sure to delete this smart link?"
                                    okText="Yes, Delete"
                                    cancelText="No, Ignore"
                                    placement='left'
                                    onConfirm={ () => setDeleteLink({index: index , ...link}) }
                                >
                                    <DeleteOutlined style={{color:'red'}}  />
                                    </Popconfirm>
                                </div>
                            </div>
                            <div className='mobile card-footer'>
                            
                            <p className='date-created'>
                                {new Date(link.created_at).toLocaleString('en-GB',
                                    {
                                        day: 'numeric',
                                        month: 'short',
                                        year: 'numeric'
                                    })}
                            </p>
                                <div style={{display:'flex' , flexDirection:'row' , gap:"10px"}}> 
                                    <p className='date-created'> {link.clicks || 0} Clicks</p>
                                    <p className='date-created'> {link.shares || 0} Shares</p>
                                </div>
                            </div>
                        </div>)
                    }


                </div>

                {
                    (Array.isArray(links) == true && links.length < 1) && <>
                    
                    
                    <div className='oia-intro'>
                        <p>Start creating smart links, that directly opens in app and gives you a smart analytics.</p>
                    </div>
                    
                    </>
                }


            </div>


            <Modal title="Create Smart Link" confirmLoading={loading} open={showCreate} okText="Create Smart Link" onOk={() => {
                setCallPostAPI(true)
            }} onCancel={() => setShowCreate(false)}>
                <Input placeholder='Paste your normal link to create smart link' style={{marginTop:'20px'}} onChange={(e) => setNewURL(e.target.value)} />
                <Collapse style={{marginTop:'20px'}}  items={collaps_items} />
            </Modal>


            <Drawer
                title={drawerData?.link_preview?.title || "Add title"}
                placement="right"
                open={showDrawer}
                style={{ backgroundColor: '#f5f5ff' }}
                width={'500px'}
                onClose={() => { setShowDrawer(false) }}
                extra={
                    <Space>
                        <Button onClick={() => { setShowDrawer(false) }} > Cancel</Button>
                        <Button type="primary"
                            onClick={() => { }}>
                            {drawerData.short_url ? "Update" : "Create"}
                        </Button>
                    </Space>
                }
            >


                <div className="btn-tmp-bldr">


                    {drawerData?.link_preview?.image && <div className="img-box">
                        <img style={{ maxWidth: '100%', maxHeight: '200px', borderRadius: 'inherit', objectFit: 'cover', width: '100%' }} src={drawerData?.link_preview?.image} />
                    </div>
                    }


                    <div style={drawerData?.link_preview?.image == undefined ? { marginTop: '40px', padding: '20px' } : { marginTop: '10px', padding: '10px' }} >

                        <EditText style={{ width: '90%', padding: '10px', fontWeight: 'bold', overflow: 'hidden' }}
                            inline={true} onSave={(e) => {
                            }} defaultValue={drawerData?.link_preview?.title || "Click to edit title"} />

                        <EditTextarea style={{ width: '90%', padding: '10px', fontSize: '12px' }}
                            onSave={(e) => {
                            }}
                            inline={true} rows={1} defaultValue={drawerData?.link_preview?.description || "Click to edit description"} />

                    </div>
                </div>

                <Upload
                    action=""
                    accept="image/*"
                    beforeUpload={() => { return false }}
                    listType="picture"
                    onChange={({ file, fileList }) => { }}
                    maxCount={1}
                >
                    <Button type="primary" style={{ marginTop: '20px' }} icon={<UploadOutlined />} block>
                        {drawerData?.body?.image_url ? "Change cover image" : "Upload Cover image"}
                    </Button>
                </Upload>


            </Drawer>

            

        </div>
    )

}

export default Oia;
